import { createInterfaceId } from '@gitlab-org/di';
import { Disposable } from '@gitlab-org/disposable';

export type WebviewThemeKeyPrefix = '--gl';
export type WebviewThemeKeySuffixes = 'foreground' | 'background';

export type WebviewThemeKeys = `${WebviewThemeKeyPrefix}-${WebviewThemeKeySuffixes}`;

export type ThemeStyles = Partial<Record<WebviewThemeKeys, string>>;

export type ThemeInfo = {
  styles: ThemeStyles;
};

export const isThemeInfo = (theme: unknown): theme is ThemeInfo =>
  typeof theme === 'object' && theme !== null && 'styles' in theme;

export interface ThemeSubscriptionListener {
  (theme: ThemeInfo): void;
}

export interface ThemeProvider {
  getTheme(): ThemeInfo;
  onThemeChange(callback: ThemeSubscriptionListener): Disposable;
}
export const ThemeProvider = createInterfaceId<ThemeProvider>('ThemeProvider');

export interface ThemePublisher {
  publishTheme(theme: ThemeInfo): void;
}
export const ThemePublisher = createInterfaceId<ThemePublisher>('ThemePublisher');
